import { render } from "./SidebarV2.vue?vue&type=template&id=79f00c9c"
import script from "./SidebarV2.vue?vue&type=script&lang=js"
export * from "./SidebarV2.vue?vue&type=script&lang=js"

import "./SidebarV2.vue?vue&type=style&index=0&id=79f00c9c&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__